import { createModule } from 'saga-slice';
import { takeLatest } from 'redux-saga/effects';
import Swal from '#/swal';
import { sagaApi } from '#/apis';
import {
    failReducer, loadingReducer, readAllSuccess, createSuccess, deleteSuccess, updateSuccess
} from 'saga-slice-helpers';


const sagaSlice = createModule({

    name: 'documents',
    initialState: {
        isFetching: false,
        data: {},
        error: null
    },

    reducers: {

        documentFAIL: failReducer,

        fetchDocuments: loadingReducer,
        fetchDocumentsSuccess: readAllSuccess,

        generateDocuments: loadingReducer,
        generateDocumentsSuccess: readAllSuccess,

        createDocument: loadingReducer,
        createDocumentSuccess: createSuccess,

        deleteDocument: loadingReducer,
        deleteDocumentSuccess: deleteSuccess,

        updateDocument: loadingReducer,
        updateDocumentSuccess: updateSuccess

    },

    sagas: A => ({

        [A.fetchDocuments]: {
            *saga () {

                yield sagaApi.get(
                    '/documents',
                    A.fetchDocumentsSuccess,
                    A.documentFAIL
                );
            },
            taker: takeLatest
        },

        [A.generateDocuments]: {
            *saga ({ payload }) {
                const { name } = payload;
                delete payload.name;
                yield sagaApi.get(
                    `/documents/${name}/generate`,
                    // payload,
                    A.generateDocumentsSuccess,
                    A.documentFAIL
                );
            },
            taker: takeLatest
        },

        [A.createDocument]: {
            *saga ({ payload }) {
                yield sagaApi.post('/documents', payload, A.createDocumentSuccess, A.documentFAIL);
            }
        },

        [A.deleteDocument]: {
            *saga ({ payload: id }) {

                const { value } = yield Swal.fire.warning();

                if (value){

                    yield sagaApi.delete(`/documents/${id}`, null, A.deleteDocumentSuccess, A.documentFAIL);
                }
            }
        },
        [A.createDocumentSuccess]: function* (){
            yield Swal.fire.success();
        },
        [A.updateDocumentSuccess]: function* (){
            yield Swal.fire.success();
        },
        [A.deleteDocumentSuccess]: function* (){
            yield Swal.fire.success();
        },

        [A.updateDocument]: {
            *saga ({ payload }) {
                const { id } = payload;

                yield sagaApi.put(`/documents/${id}`, payload, A.updateDocumentSuccess, A.documentFAIL);
            }
        }

    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
